<template>
	<v-card flat max-width="950px" class="mx-auto transparent">
        <HeadRoot 
            title="My Group"
            :length="0"
            btn_txt=""
            btn_to="" />
        
        <v-card flat class="transparent mt-6" v-if="loaded">
            <v-card-text>
                <div class="display-1 font-weight-light accent--text">{{group.str}}</div>
                <div class="body-1 font-weight-regular grey--text text--darken-4">{{group.reference}}</div>
            </v-card-text>
        </v-card>

        <SendingLoader v-if="!loaded"/>

        <Groupmates v-if="loaded"/>

	</v-card>
</template>

<script>
import Groups from '@/firebase/groups'
import Groupmates from '@/components/myGroup/Groupmates'
import Presentations from '@/components/myGroup/Presentations'

export default {
    data: () => ({
        loaded: false,
        group: null,
        schedule: null,
        tab: 0
    }),
    components: {
        Groupmates,
        Presentations
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            Groups.get(this.user.group)
                    .then(response => {
                        if (response.status === true) {
                            this.group = response.doc.data();
                            this.group.id = response.doc.id;
                            this.group.str = this.group.day + ' / ' + this.group.hour;
                            this.loaded = true;
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                        }
                    });
        }
    }
}
</script>
